export default function getBackgroundColor(theme: any) {
  return theme.palette.getContrastText(theme.palette.primary.main) === '#fff'
    ? theme.palette.primary.dark
    : theme.palette.primary.light;
}
